import React, { useState, useEffect } from "react";

// import icons
import { IoCardOutline } from "react-icons/io5";

// sample data for invoices
const sampleInvoices = [
  {
    invoice_id: "001",
    due_date: "2024-09-30",
    rent_invoice: "8000",
    water_invoice: "500",
    garbage_charge: "200",
    service_charge: "300",
    late_fee: "50",
    arrears: "1000",
    houseNumber: "12",
    payment_status: "unpaid",
  },
  {
    invoice_id: "002",
    due_date: "2024-10-05",
    rent_invoice: "8500",
    water_invoice: "600",
    garbage_charge: "250",
    service_charge: "350",
    late_fee: "0",
    arrears: "0",
    houseNumber: "13",
    payment_status: "unpaid",
  },
  {
    invoice_id: "003",
    due_date: "2024-09-15",
    rent_invoice: "7800",
    water_invoice: "550",
    garbage_charge: "220",
    service_charge: "310",
    late_fee: "0",
    arrears: "500",
    houseNumber: "14",
    payment_status: "fully_paid",
  },
];

// Main component
const PendingInvoicesCard = ({ setShowPay }) => {
  const [invoicesReceived, setInvoicesReceived] = useState([]);
  const [invoices, setInvoices] = useState([]);
  const [visibleInvoices, setVisibleInvoices] = useState(5); // Show 5 invoices initially
  const [expandedCardIndex, setExpandedCardIndex] = useState(null); // Track which card is expanded

  // Simulate data fetching with useEffect
  useEffect(() => {
    setInvoicesReceived(sampleInvoices);
  }, []);

  // Transform the sample data into the format needed
  useEffect(() => {
    if (invoicesReceived.length > 0) {
      setInvoices(transformInvoices(invoicesReceived));
    }
  }, [invoicesReceived]);

  // Expand/collapse card functionality
  const toggleExpandCard = (index) => {
    setExpandedCardIndex(expandedCardIndex === index ? null : index);
  };

  // "See More" functionality
  const handleSeeMore = () => {
    setVisibleInvoices((prev) => prev + 5); // Load 5 more invoices
  };

  const handleHideAll = () => {
    setVisibleInvoices(5); // Reset to showing only 5 invoices
  };

  const cardStyle = {
    backgroundColor: "#ffffff",
    boxShadow: "0px 0px 5px 0px rgba(0, 0, 0, 0.28)",
    minHeight: "55px",
    borderRadius: "10px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    margin:"0px",
    marginBottom: "10px",
  };

  const iconStyle = {
    marginLeft: "10px",
  };

  const invoiceTypeStyle = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    fontFamily: "Karla , sans-serif",
    fontSize: "18px",
  };

  const dueDateStyle = {
    fontFamily: "Roboto, sans-serif",
    color: "#A8B4CC",
    fontSize: "14px",
    margin: "0px",
  };

  const amountStyle = {
    marginRight: "10px",
  };

  const extraInfo = {
    backgroundColor: "#fff",
    width: "100%",
    border: "1px solid #ddd",
    margin: "20px 0px",
    padding: "1rem",
    borderRadius: "5px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  };
  const extraInfoTitle = {
    fontSize: "18px",
    fontFamily: "Karla, sans-serif",
    fontWeight: "500",
    marginBottom: "10px",
  };

  const tile = {
    fontSize: "16px",
    fontFamily: "Poppins, sans-serif",
    fontWeight: "200"
  }
  const detailsAndTitle = {
    display: "flex",
    width: "70%",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "5px",
  }
  const details = {
    fontWeight: "400",
  }
  const makePaymentButton = {
    marginTop: "10px",
    padding: "7px 10px", 
    border: "none",
    backgroundColor: "#0B2C3C",
    color: "#fff",
    borderRadius: "5px",
  };

  return (
    <div>
      {invoices.slice(0, visibleInvoices).map((invoice, index) => (
        <div
          key={index}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <button
            style={{
              width: "100%",
              backgroundColor: "transparent",
              border: "none",
            }}
            onClick={() => toggleExpandCard(index)}
          >
            <div style={cardStyle}>
              <div style={iconStyle}>
                <IoCardOutline fontSize={25} />
              </div>
              <div style={invoiceTypeStyle}>
                <div>House { invoice?.houseNumber}</div>
                <div style={dueDateStyle}>{invoice?.dueDate}</div>
              </div>
              <div style={amountStyle}>{invoice?.totalAmount}</div>
            </div>
          </button>

          {/* Expanded card details */}
          {expandedCardIndex === index && (
            <div style={extraInfo}>
              <div style={extraInfoTitle}>Invoice Details</div>
              <div style={detailsAndTitle}>
                <div style={tile}>Invoice ID:</div>{" "}
                <div style={details}>{invoice.id}</div>
              </div>
              <div style={detailsAndTitle}>
                <div style={tile}>Rent:</div>{" "}
                <div style={details}>{invoice.rent}</div>
              </div>
              <div style={detailsAndTitle}>
                <div style={tile}>Water:</div>{" "}
                <div style={details}>{invoice.water}</div>
              </div>
              <div style={detailsAndTitle}>
                <div style={tile}>Garbage Charge:</div>{" "}
                <div style={details}>{invoice.garbage}</div>
              </div>
             
              <div style={detailsAndTitle}>
                <div style={tile}>Other Charges:</div>{" "}
                <div style={details}>{invoice.otherCharges}</div>
              </div>
              <div style={detailsAndTitle}>
                <div style={tile}>Total Payable:</div>{" "}
                <div style={details}>{invoice.totalPayable}</div>
              </div>

              <button style={makePaymentButton}>
                Make Payment
              </button>
             
            </div>
          )}
        </div>
      ))}

      {/* See More and Hide All buttons */}
      {visibleInvoices < invoices.length && (
        <div className="see-more-buttons-container">
          <button className="see-more-button" onClick={handleSeeMore}>
            See More
          </button>
        </div>
      )}
      {visibleInvoices > 5 && (
        <div className="see-more-buttons-container">
          <button className="hide-all-button" onClick={handleHideAll}>
            Hide All
          </button>
        </div>
      )}
    </div>
  );
};

function transformInvoices(invoices) {
  const getRelativeDueDate = (dueDate) => {
    if (!dueDate) return "no due date";

    const today = new Date();
    const due = new Date(dueDate);
    const diffTime = due - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); // Difference in days

    if (diffDays > 0) {
      return `due in ${diffDays} day${diffDays > 1 ? "s" : ""}`;
    } else if (diffDays < 0) {
      return `${Math.abs(diffDays)} day${
        Math.abs(diffDays) > 1 ? "s" : ""
      } ago`;
    } else {
      return "Today";
    }
  };

  return invoices
    .filter((invoice) => invoice.payment_status !== "fully_paid") // Filter out fully paid invoices
    .map((invoice) => {
      const totalAmount = (
        parseFloat(invoice.rent_invoice || 0) +
        parseFloat(invoice.water_invoice || 0) +
        parseFloat(invoice.garbage_charge || 0) +
        parseFloat(invoice.service_charge || 0) +
        parseFloat(invoice.late_fee || 0) +
        parseFloat(invoice.arrears || 0)
      ).toFixed(2);

      return {
        id: `INV${(invoice.invoice_id || "").padStart(3, "0")}`, // Format ID with leading zeros
        dueDate: getRelativeDueDate(invoice.due_date),
        totalAmount: totalAmount,
        rent: invoice.rent_invoice || "0",
        water: invoice.water_invoice || "0",
        garbage: invoice.garbage_charge || "0",
        otherCharges: (
          parseFloat(invoice.service_charge || 0) +
          parseFloat(invoice.late_fee || 0) +
          parseFloat(invoice.arrears || 0)
        ).toFixed(2),
        totalPayable: totalAmount,
        houseNumber: invoice.houseNumber || "N/A",
      };
    });
}

export default PendingInvoicesCard;
